import React, { useEffect, useState } from "react";
import "./Common_Form.css";
import { Col, Row, Form } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import classNames from "classnames";
import Select from "react-select";
import Cookies from "js-cookie";
import { ToastContainer, toast } from "react-toastify";

import indiaStatesCities from "../../indiaStatesCities/IndiaStatesCities";
import {
  getCities,
  getCourses,
  getStates,
  postEnquiryForm,
} from "../../../utils/apis/enquiry_form/Enquiry_Form";
import { Select2Data } from "../../../utils/common";

const Common_Form = () => {
  const navigate = useNavigate();

  // Courses
  const Courses = [
    { value: 8, label: "Diploma" },
    { value: 9, label: "Graduate" },
    { value: 10, label: "Post Graduate" },
    // { value: "12th_pass", label: "12th Pass" },
    // { value: "10th_pass", label: "10th Pass" },
  ];

  const customStyles = {
    menu: (provided) => ({
      ...provided,
      fontSize: "12px !important", // 👈 change menu text size
    }),
    option: (provided) => ({
      ...provided,
      fontSize: "12px !important", // 👈 each option text
    }),
  };

  const states = Object.keys(indiaStatesCities).map((state) => ({
    value: state,
    label: state,
  }));



  const {
    control,
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm();

  const selectedState = watch("state_id");

  const onSubmit = async (data) => {
    const formData = new FormData();

    formData.append("name", data?.name);
    formData.append("email", data?.email);
    formData.append("mobile", data?.contact_no);
    formData.append("state_id", data?.state_id?.value ?? null);
    formData.append("district_id", data?.city_id?.value ?? null);
    formData.append("course_id", data?.course_id?.value ?? null);
    formData.append("specilization_id", data?.specilization_id?.value ?? null);

    // profcyma.in
    formData.append("source_name", "GoogleAds_Prof_llp_mba");
    formData.append("api_key", "profcyma-new-website");

    // ✅ Add UTM cookies
    formData.append("utm_source", Cookies.get("utm_source") || "");
    formData.append("utm_medium", Cookies.get("utm_medium") || "");
    formData.append("utm_campaign", Cookies.get("utm_campaign") || "");
    formData.append("utm_id", Cookies.get("utm_id") || "");
    formData.append("lpurl", Cookies.get("lpurl") || "");

    formData.forEach((value, key) => {
      console.log(key + ": " + value);
    });

    try {
      const res = await postEnquiryForm(formData);
      if (res?.success) {
        // ✅ Download brochure
        const link = document.createElement("a");
        link.href = "/assets/brochure/brochure_2027.pdf"; // Path to your brochure in public folder
        link.download = "Brochure.pdf"; // File name for user
        link.click();

        navigate("/thank-you");
      } else {
        console.log("res", res);
        toast.error("You've already submitted an inquiry.");
      }
    } catch (error) {
      toast.error("You've already submitted an inquiry.");
    }
  };

  const [cities, setCities] = useState([]);

  const [statesData, setStatesData] = useState([]);

  useEffect(() => {
    const GetAllStates = async (id) => {
      const response = await getStates(1);

      if (response?.success) {
        setStatesData(await Select2Data(response?.data, "state_id"));
      }
    };

    GetAllStates();
  }, []);

  const GetAllCities = async (id) => {
    console.log("id", id);

    const response = await getCities(id);

    if (response?.success) {
      setCities(await Select2Data(response?.data, "city_id"));
    }
  };

  return (
    <div className="banner_form">
      <div className="container">
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row className="form_details">
            {/* Full Name */}
            <Col md={12} className="p-1">
              <Form.Group className="mb-2">
                <Form.Control
                  name="name"
                  className={classNames("", {
                    "is-invalid": errors?.name,
                  })}
                  type="text"
                  {...register("name", {
                    required: "Name is required",
                    pattern: {
                      value: /^[A-Za-z ]*$/,
                      message: "Name must contain only letters",
                    },
                  })}
                  onKeyDown={(event) => {
                    if (!/[A-Z-a-z ]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  placeholder="Enter Full Name"
                />

                {errors.name && (
                  <span className="text-danger">{errors.name.message}</span>
                )}
              </Form.Group>
            </Col>

            {/* Email */}
            <Col md={12} className="p-1">
              <Form.Group className="mb-2">
                <Form.Control
                  className={classNames("", {
                    "is-invalid": errors?.email,
                  })}
                  type="email"
                  {...register("email", {
                    required: "Email Address is required",
                    pattern: {
                      value: /^([A-Za-z0-9_\-\.])+\@(?!(?:[A-Za-z0-9_\-\.]+\.)?([A-Za-z]{2,4})\.\2)([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/,
                      message: "Invalid E-Mail Address",
                    },
                  })}
                  placeholder="Enter email Address"
                />
                {errors.email && (
                  <span className="text-danger">{errors.email.message}</span>
                )}
              </Form.Group>
            </Col>

            {/* Mobile Number */}
            <Col md={12} className="p-1">
              <Form.Group className="mb-2">
                <Form.Control
                  className={classNames("", {
                    "is-invalid": errors?.contact_no,
                  })}
                  type="tel"
                  {...register("contact_no", {
                    required: "Mobile Number is required",
                    pattern: {
                      value: /^\d{10}$/,
                      message: "Mobile Number must be a 10-digit number",
                    },
                    maxLength: 10,
                  })}
                  onKeyDown={(event) => {
                    const key = event.key;
                    if (
                      !/^\d$/.test(key) &&
                      ![
                        "Backspace",
                        "Delete",
                        "ArrowLeft",
                        "ArrowRight",
                        "Tab",
                        "Home",
                        "End",
                      ].includes(key)
                    ) {
                      event.preventDefault();
                    }
                  }}
                  placeholder="Enter Mobile Number"
                  maxLength={10}
                />
                {errors.contact_no && (
                  <span className="text-danger">
                    {errors.contact_no.message}
                  </span>
                )}
              </Form.Group>
            </Col>

            {/* State */}
            <Col md={6} xs={6} className="p-1">
              <Form.Group className="mb-2">
                <Controller
                  name="state_id" // name of the field
                  className={classNames("", {
                    "is-invalid": errors?.state_id,
                  })}
                  {...register("state_id", {
                    required: "Select State",
                  })}
                  control={control}
                  render={({ field }) => (
                    <Select
                      styles={customStyles}
                      // styles={{
                      //   control: (baseStyles) => ({
                      //     ...baseStyles,
                      //     borderColor: errors.state_id ? "red" : baseStyles,
                      //   }),
                      // }}
                      {...field}
                      options={statesData}
                      onChange={(selectedOption) => {
                        console.log("selectedOption", selectedOption);

                        field.onChange(selectedOption);
                        GetAllCities(selectedOption.value);
                        setValue("state_id", selectedOption);
                        setValue("city_id", null);
                      }}
                    />
                  )}
                />

                {errors.state_id && (
                  <span className="text-danger">{errors.state_id.message}</span>
                )}
              </Form.Group>
            </Col>

            {/* City */}
            <Col md={6} xs={6} className="p-1">
              <Form.Group className="mb-2">
                <Controller
                  name="city_id" // name of the field
                  {...register("city_id", {
                    required: "Select City",
                  })}
                  control={control}
                  render={({ field }) => (
                    <Select
                      styles={customStyles}
                      {...field}
                      options={cities}
                      onChange={(selectedOption) => {
                        field.onChange(selectedOption);
                        setValue("city_id", selectedOption);
                      }}
                    />
                  )}
                />

                {errors.city_id && (
                  <span className="text-danger">{errors.city_id.message}</span>
                )}
              </Form.Group>
            </Col>

            {/* Course */}
            <Col md={12} className="p-1">
              <Form.Group className="mb-2">
                <Controller
                  name="course_id"
                  control={control}
                  rules={{ required: "Select Qualification" }}
                  render={({ field }) => (
                    <Select
                      {...field}
                      styles={customStyles}
                      options={Courses}
                      placeholder="Select Highest Qualification*"
                    />
                  )}
                />
                {errors.course_id && (
                  <span className="text-danger">
                    {errors.course_id.message}
                  </span>
                )}
              </Form.Group>
            </Col>

            {/* checkbox */}
            <Col md={12} className="p-1">
              <Form.Check
                required
                type="checkbox"
                label="I agree to receive information regarding my submitted enquiry on Dr. D Y Patil Vidyapeeth - Centre For Online Learning"
              />
            </Col>
          </Row>

          <div className="submit_btn text-center">
            <button type="submit" className="s_btn btn-primary">
              Submit
            </button>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default Common_Form;
